import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NavbarComponent } from "./navbar/navbar.component";
import { OAuthService } from 'angular-oauth2-oidc';
import { HttpClient } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { ChatBotComponent } from "./chat-bot/chat-bot.component";

@Component({
  selector: 'app-root',
  imports: [NavbarComponent, RouterOutlet, CommonModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
  providers: [OAuthService, HttpClient]
})
export class AppComponent {
  title = 'email-signature-frontend';

  oauthService = inject(OAuthService);

  get isLoggedIn(): boolean {
    return this.oauthService.hasValidAccessToken();
  }
}
